import { Box, Paper } from "@mui/material";
import DrawerHeader from "../components/DrawerHeader";
import Dashboard from "./Dashboard";
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import { CommonTexts } from "locale/es";
import IndexWithSearchBar from "components/PageBuilder/IndexWithSearchBar";
import PatientDetails from "./Dashboard/PatientDetails";
import { useSelector } from "react-redux";
import { isEmptyObj } from "utils/HelperFunctions";
import ScoreCard from "./Dashboard/ScoreCard";

const HomePage = () => {
  const selectedPatient = useSelector(({ patient }) => patient);

  const containerStyles = selectedPatient.id
    ? { width: 1000, mt: 2, mb: -2, display: "flex" }
    : { p: 2, m: 2, mx: { md: 10, lg: 30 } };

  return (
    <Box component='main' sx={{ flex: 1, p: 3, mb: 10 }}>
      <DrawerHeader />
      <BreadCrumbs
        name={CommonTexts.PARTICIPANT_DATA}
        icon={<MonitorHeartIcon sx={{ mr: 0.5 }} fontSize='inherit' />}
      />
      <Box sx={containerStyles}>
        <IndexWithSearchBar />
      </Box>
      {!isEmptyObj(selectedPatient) && (
        <Paper elevation={3} sx={{ p: 2, m: 4, px: 10 }}>
          <PatientDetails />
          <ScoreCard />
        </Paper>
      )}
      <Dashboard />
    </Box>
  );
};

export default HomePage;
